import React, { useState, useRef } from 'react';
import { useSettings } from '../../hooks/useSettings';

const NotificationsTab = ({ settings, onSave }) => {
  const { updateSettings } = useSettings();
  const [emailNotifications, setEmailNotifications] = useState(settings?.email_notifications ?? true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const previousValue = useRef(true);

  const handleSave = async (e) => {
    e.preventDefault();
    
    previousValue.current = emailNotifications;
    setSaving(true);
    setMessage(null);
    setError(null);

    try {
      await updateSettings({
        email_notifications: emailNotifications,
      });
      setMessage('Notification preferences saved successfully');
      if (onSave) onSave();
    } catch (err) {
      setEmailNotifications(previousValue.current);
      setError(err.message);
    }
    setSaving(false);
  };

  return (
    <div className="settings-section">
      <h2>Notifications</h2>
      <p className="description">Manage how you receive notifications and updates</p>

      {error && <div className="error-message">{error}</div>}
      {message && <div className="success-message">{message}</div>}

      <form onSubmit={handleSave}>
        <div className="form-group">
          <div className="form-checkbox">
            <input
              type="checkbox"
              id="emailNotifications"
              checked={emailNotifications}
              onChange={(e) => setEmailNotifications(e.target.checked)}
              disabled={saving}
            />
            <label htmlFor="emailNotifications">
              <strong>Email Notifications</strong>
              <p style={{ fontWeight: 'normal', fontSize: '0.875rem', color: '#6b7280', margin: '4px 0 0 0' }}>
                Receive email updates about your agent runs, billing, and important announcements
              </p>
            </label>
          </div>
        </div>

        <button type="submit" className="btn-primary" disabled={saving}>
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </form>
    </div>
  );
};

export default NotificationsTab;
